import { Alert, Box, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Modal, Snackbar, Tab, Tabs } from "@mui/material";
import { useState, useEffect } from "react";
import { style as modalStyle } from "../../../components/Loading/Loading";
import { useForm, FormProvider } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ErrorHandling } from "../../../components/Errors/Errors";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";
import TabPanel from "../../../components/Tabpanel/Tabpanel";
import { logout } from "../../../state/slices/userSlice";
import { Geral } from "./abas/Geral";
import { Localizacao } from "./abas/Localizacao";
import { Tensao } from "./abas/Tensao";
import { Documentos } from "./abas/Documentos";
import styles from "./Cadastro.module.css";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import ServConsultaAcesso from "../../../services/login/servConsultaAcesso";
import servParam from "../../../services/login/servParam";
import { OpcoesFases } from "../../../components/Combobox/Fases";
import { OpcoesTipoInscricao } from "../../../components/Combobox/TipoInscricao";
import { formatarTelefone, formatarNumero, formatarCnpj } from "../../../infra/utils/FormataValores";
import { validarCnpj, validarCpf } from "../../../infra/utils/ValidacaoCpf";
import { OpcoesUF } from "../../../components/Combobox/UF";
import { format, parse } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";

const schema = yup.object().shape({
    Id: yup.number("Só é possível informar números nesse campo"),
    CodigoResponsavelTecnico: yup.number("Só é possível informar números nesse campo"),
    Situacao: yup.number("Só é possível informar números nesse campo"),
    // Protocolo: yup.number().required("Campo obrigatório"),
    CodigoUC: yup.number("Só é possível informar números nesse campo").min(0, "O valor deve ser positivo").integer("O valor não deve possuir casas decimais").nullable(true).transform((valor, strValor) => valor === Number(valor) ? valor : null).lessThan(1000000000000, "O valor informado é muito extenso"),
    TipoInscricao: yup.object().shape({
        label: yup.string(),
        value: yup.number()
    }),
    Inscricao: yup.string().required("Campo obrigatório")
        .when('TipoInscricao', {
            is: (val) => val?.value === 1,
            then: yup.string().test("is-cpf", "CPF inválido", (value) => validarCpf(value)),
            otherwise: yup.string().test("is-cnpj", "CNPJ inválido", (value) => validarCnpj(value))
        }),
    Nome: yup.string().max(60, "Máximo de 60 caracteres").required("Campo obrigatório"),
    FoneCelular1: yup.string().typeError("Só é possível informar caracteres válidos nesse campo"),
    FoneCelular2: yup.string().typeError("Só é possível informar caracteres válidos nesse campo"),
    Email: yup.string().max(100, "Máximo de 100 caracteres"),
    Endereco: yup.string().max(100, "Máximo de 100 caracteres").required("Campo obrigatório"),
    CEP: yup.string().when('tabIndex', {
        is: 1,
        then: yup.string().required("Campo obrigatório").trim().min(1)
    }),
    CodigoCidade: yup.object().shape({
        value: yup.number().required("Campo obrigatório"),
        label: yup.string()
    }),
    Rua: yup.string().max(250, "Máximo de 250 caracteres").when('tabIndex', {
        is: 1,
        then: yup.string().required("Campo obrigatório").trim().min(1)
    }),
    NumeroEnd: yup.number("Só é possível informar números nesse campo").typeError("Valor inválido. Este campo é obrigatório.").integer("O valor não deve possuir casas decimais").required("Campo obrigatório"),
    Complemento: yup.string().max(250, "Máximo de 250 caracteres"),
    UF: yup.object().shape({
        value: yup.string(),
        label: yup.string()
    }).when('tabIndex', {
        is: 1,
        then: yup.object().shape({
            value: yup.string().required("Campo obrigatório").trim().min(1),
            label: yup.string()
        })
    }),
    TensaoAtendimento: yup.string().required("Campo obrigatório"),
    PotenciaInstalada: yup.string().max(250, "Máximo de 250 caracteres").required("Campo obrigatório"),
    FatorPotencia: yup.number("Só é possível informar números nesse campo").typeError("Só é possível informar números nesse campo").integer("O valor não deve possuir casas decimais").min(0, "O fator potência deve ser maior que 0%").max(100, "O fator potência deve ser menor que 100%").required("Campo obrigatório"),
    Longitude: yup.number("Só é possível informar números nesse campo"),
    Latitude: yup.number("Só é possível informar números nesse campo"),
    CodigoTipoGeracao: yup.object().shape({
        value: yup.number().required(),
        label: yup.string()
    }),
    tabIndex: yup.number()
});

const defaultValues = {
    Id: 0,
    Protocolo: "",
    CodigoUC: "",
    Nome: " ",
    Endereco: " ",
    CEP: " ",
    CodigoCidade: {
        value: 0,
        label: " "
    },
    Cidade: " ",
    Email: "",
    Rua: " ",
    NumeroEnd: 0,
    FoneCelular1: "",
    FoneCelular2: "",
    UF: {
        value: "",
        label: ""
    },
    TipoInscricao: {
        value: 1,
        label: "CPF"
    },
    // CodigoTipoGeracao: {
    //     value: 0,
    //     label: " "
    // },
    TensaoAtendimento: " ",
    TipoConexao: 1,
    PotenciaInstalada: "0",
    FatorPotencia: 0,
    Longitude: 0,
    Latitude: 0,
    tabIndex: 0
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const Cadastro = ({ setOpen, recordForEdit, addOrEdit, pesquisar, novoCadastro, setEhNovoCadastro }) => {
    const methods = useForm({ defaultValues: defaultValues, resolver: yupResolver(schema) })
    const user = useSelector(state => state.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const uc = useSelector(state => state.uc);

    const [tabIndex, setTabIndex] = useState(0);
    const [podeSalvar, setPodeSalvar] = useState(true);
    const [camposDesabilitados, setCamposDesabilitados] = useState(false);
    const [camposDesabilitadosUc, setCamposDesabilitadosUc] = useState(false);
    const [erroAoRecuperarConsumidor, setErroAoRecuperarConsumidor] = useState(false);
    const [desabilitarUcInscricao, setDesabilitarUcInscricao] = useState(false);

    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false);
    const [typeAlert, setTypeAlert] = useState("error");
    const [isLoading, setIsLoading] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [documentosObrigatorios, setDocumentosObrigatorios] = useState([]);

    useEffect(() => {
        const situacoesBloqueadas = [1, 2, 3, 4];

        const recuperarDocumentosIniciais = async () => {
            try {
                setIsLoading(true);

                let response = await servParam.RecuperarDocumentosObrigatorios(5);

                setDocumentosObrigatorios(response.Content);

                setIsLoading(false);

            } catch (err) {
                setIsLoading(false);

                setTypeAlert("error");

                return ErrorHandling(
                    err?.request?.status,
                    err?.message,
                    setOpenError,
                    setErrorMessage,
                    dispatch,
                    logout,
                    navigate,
                    err?.response?.data?.Message
                );
            }
        }

        if (recordForEdit !== null && novoCadastro === false) {
            const recuperarDados = async () => {
                try {
                    setIsLoading(true);

                    let data = await ServConsultaAcesso.RecuperarParaEditar(recordForEdit?.id);
                    var docsObrigatorios = await servParam.RecuperarDocumentosObrigatorios(5);

                    docsObrigatorios = docsObrigatorios.Content;

                    mapearRetorno(data.Content);
                    mapearDocsObrigatorios(docsObrigatorios, data.Content.Documentos);

                    verificaCamposUc();

                    setIsLoading(false);

                    verificarCampoUcInscricao(data.Content);

                } catch (err) {
                    setIsLoading(false);

                    return ErrorHandling(
                        err?.response?.status,
                        err?.Message,
                        setOpenError,
                        setErrorMessage,
                        dispatch,
                        logout,
                        navigate,
                        err?.response?.data?.Message
                    )
                }
            }

            const verificaCamposUc = async () => {
                setErroAoRecuperarConsumidor(false);

                if (!methods.getValues("CodigoUC") || !methods.getValues("Inscricao")) {
                    return;
                }

                let codigoUc = methods.getValues("CodigoUC").toString(),
                    inscricao = methods.getValues("Inscricao");

                if (codigoUc.trim().length <= 0
                    || inscricao.trim().length <= 0) {
                    return;
                }

                if (methods.getValues("TipoInscricao")?.value == 1) {
                    inscricao = formatarCnpj(methods.getValues("Inscricao"));
                    inscricao = inscricao.replaceAll("_", "");
                } else {
                    inscricao = formatarCnpj(methods.getValues("Inscricao"));
                }

                if (inscricao < 11) {
                    return;
                }

                var dto = {
                    CodigoUC: methods.getValues("CodigoUC"),
                    Inscricao: inscricao
                };

                try {
                    const data = await ServConsultaAcesso.CarregarDadosDoConsumidor(dto);

                    setCamposDesabilitadosUc(true);
                } catch (error) {
                    setCamposDesabilitadosUc(false);
                    setErroAoRecuperarConsumidor(true);
                }
            }

            if (situacoesBloqueadas.includes(recordForEdit.Situacao)) {
                setPodeSalvar(false);
                setCamposDesabilitados(true);
            }

            recuperarDados();
        } else {
            const setarTipoGeracaoDefault = () => {
                methods.setValue("CodigoTipoGeracao", {
                    value: 3,
                    label: "UFV - Solar - Radiação solar"
                });
            }

            setarTipoGeracaoDefault();
            recuperarDocumentosIniciais();
        }

    }, [recordForEdit]);

    const mapearCamposConsumidorDefault = () => {
        methods.setValue("CEP", " ");
        methods.setValue("CodigoCidade", {
            value: 0,
            label: " "
        });
        methods.setValue("Cidade", " ")
        methods.setValue("Celular1", "");
        methods.setValue("Celular2", "");
        methods.setValue("Nome", " ");
        methods.setValue("NumeroEnd", 0);
        methods.setValue("Rua", " ");
        methods.setValue("Complemento", " ");
        methods.setValue("Endereco", " ");
        methods.setValue("UF", {
            value: " ",
            label: " "
        });
        methods.setValue("Email", "");
    }

    const handleCadastroConsulta = methods.handleSubmit(async (data) => {
        try {
            if (data.TipoInscricao?.value === 1) {
                let cpf = formatarNumero(data.Inscricao);

                if (cpf !== ' ' && !validarCpf(cpf)) {
                    setTypeAlert("warning");
                    setErrorMessage("A Inscrição informada é inválida");
                    return setOpenError(true);
                }

                data.Inscricao = cpf;
            } else {
                let cnpj = data.Inscricao;

                if (cnpj !== ' ' && !validarCnpj(cnpj)) {
                    setTypeAlert("warning");
                    setErrorMessage("A Inscrição informada é inválida");
                    return setOpenError(true);
                }

                data.Inscricao = cnpj;
            }

            if (erroAoRecuperarConsumidor) return;

            // Verifica se a cidade foi inserida
            // A validação é feita na aba de localização, para que não estoure aviso em outra tela
            // Caso não haja UC, deve-se obrigatoriamente definir uma cidade
            if (!data.CodigoUC && tabIndex === 1 && data.CodigoCidade?.value === 0) {
                setTypeAlert("warning");
                setErrorMessage("É necessário informar uma cidade válida.");
                return setOpenError(true);
            }

            if (data.Id == 0) {
                setIsLoading(true);

                ajustarValoresAntesDeInserirOuEditar(data);
                if (data.Complemento?.trim() === "") {
                    data.Complemento = " ";
                }

                if (data.Email?.trim() === "") {
                    data.Email = " ";
                }

                data.DataCadastro = new Date();

                console.log(data);

                const response = await ServConsultaAcesso.Inserir(data);

                data.CodigoTipoGeracao = data.TipoGeracao;

                mapearRetorno(response.Content);

                setTypeAlert("success");
                setOpenError(true);
                setErrorMessage("Dados salvos com sucesso");

                setTabIndex(1);

                pesquisar();

                setIsLoading(false);
            } else {
                setIsLoading(true);

                ajustarValoresAntesDeInserirOuEditar(data);

                const response = await ServConsultaAcesso.Editar(data);

                data.CodigoTipoGeracao = data.TipoGeracao;

                mapearRetorno(response.Content);

                setTypeAlert("success");
                setOpenError(true);
                setErrorMessage("Dados salvos com sucesso");

                setIsLoading(false);

                methods.reset({}, { keepValues: true });
            }

        } catch (err) {
            setIsLoading(false);
            return ErrorHandling(
                err?.request?.status,
                err?.message,
                setOpenError,
                setErrorMessage,
                dispatch,
                logout,
                navigate,
                err?.response?.data?.Message
            );
        }
    });

    const ajustarValoresAntesDeInserirOuEditar = (data) => {
        data.TipoConexao = data.TipoConexao.value ? data.TipoConexao.value : 1;
        data.TipoGeracao = data.CodigoTipoGeracao;
        data.CodigoTipoGeracao = data.CodigoTipoGeracao.value ? data.CodigoTipoGeracao.value : null;
        data.CodigoResponsavelTecnico = user.codigoUsuario;
        data.TipoInscricao = data?.TipoInscricao.value ? data.TipoInscricao.value : 1;
        data.UF = data?.UF.value ? data?.UF.value : ' ';
        data.Inscricao = data?.Inscricao ? data.Inscricao.replace("/", "").replace("-", "").replaceAll(".", "") : " ";
        data.Celular1 = formatarTelefone(data.Celular1);
        data.Celular2 = formatarTelefone(data.Celular2);
        data.CEP = data.CEP.replace("-", "").replaceAll("_", "");
        data.Inscricao = data?.Inscricao ? (data.Inscricao.trim() === "" ? " " : data.Inscricao) : " ";
        data.Cidade = data?.CodigoCidade?.value ? data?.CodigoCidade?.label : " ";
        data.CodigoCidade = data?.CodigoCidade?.value ? data?.CodigoCidade?.value : null;
    }

    const mapearRetorno = (data) => {
        methods.setValue("Protocolo", data.Protocolo);
        methods.setValue("Situacao", data.Situacao);
        methods.setValue("TipoInscricao", {
            value: data.TipoInscricao,
            label: OpcoesTipoInscricao.find((opcao) => opcao.value == data.TipoInscricao).label
        });
        methods.setValue("Inscricao", data.Inscricao);
        methods.setValue("Nome", data.Nome);
        methods.setValue("Celular1", data.Celular1);
        methods.setValue("Celular2", data.Celular2);
        methods.setValue("Email", data.Email);
        methods.setValue("Endereco", data.Endereco);
        methods.setValue("CEP", data.CEP);
        methods.setValue("Rua", data.Rua);
        methods.setValue("NumeroEnd", data.NumeroEnd);
        methods.setValue("Complemento", data.Complemento);
        methods.setValue("TensaoAtendimento", data.TensaoAtendimento);
        methods.setValue("PotenciaInstalada", data.PotenciaInstalada);
        methods.setValue("FatorPotencia", data.FatorPotencia);
        methods.setValue("Longitude", data.Longitude);
        methods.setValue("Latitude", data.Latitude);
        methods.setValue("Id", data.Id ? data.Id : data.CodigoConsultaAcesso);
        methods.setValue("CodigoUC", data.CodigoUC === 0 ? null : data.CodigoUC);
        methods.setValue("DataCadastro", data.DataCadastro);
        methods.setValue("TipoConexao", {
            value: data.TipoConexao,
            label: OpcoesFases.find((opcao) => opcao.value == data.TipoConexao).label
        })

        if (data.UF.trim() !== "") {
            methods.setValue("UF", {
                value: data.UF,
                label: OpcoesUF.find((opcao) => opcao.value == data.UF).label
            });
        }


        if (data.TipoGeracao) {
            methods.setValue("CodigoTipoGeracao", {
                value: data.CodigoTipoGeracao,
                label: data.TipoGeracao.Descricao
            });
        }

        if (data.CodigoCidade) {
            methods.setValue("CodigoCidade", {
                value: data.CodigoCidade,
                label: data.Cidade
            });

            methods.setValue("Cidade", data.Cidade);
        }
    }

    const mapearDocsObrigatorios = (docsObrigatorios, docsVinculados) => {
        docsObrigatorios.map((doc) => {
            if (docsVinculados.length) {
                for (let i = 0; i < docsVinculados.length; i++) {
                    if ((doc.Id == docsVinculados[i].CodigoConfigDoc) &&
                        (doc.CodigoClassificacaoDoc == docsVinculados[i].CodigoClassificacoDoc)) {
                        doc.CodigoDocumento = docsVinculados[i].CodigoDocumento;
                        doc.NomeArquivo = docsVinculados[i].NomeArquivo;
                    }
                }
            }
        });

        setDocumentosObrigatorios(docsObrigatorios);
    }

    const handleTabChange = async (event, newValue) => {
        const situacoesNaoEditaveis = [1, 2, 3, 4];

        if (erroAoRecuperarConsumidor) return;

        if (situacoesNaoEditaveis.includes(methods.getValues("Situacao"))) {
            setTabIndex(newValue);
            return;
        }

        // Verifica se a cidade foi inserida
        // A validação é feita na aba de localização, para que não estoure aviso em outra tela
        // Caso não haja UC, deve-se obrigatoriamente definir uma cidade
        if (!methods.getValues("CodigoUC") && tabIndex === 1 && methods.getValues("CodigoCidade.value") === 0) {
            setTypeAlert("warning");
            setErrorMessage("É necessário informar uma cidade válida.");
            return setOpenError(true);
        }

        if (tabIndex === 0 && methods.getValues("Id") == 0) {
            if (methods.getValues("CodigoTipoGeracao") === undefined) {
                setTypeAlert("warning");
                setOpenError(true);
                setErrorMessage("É necessário salvar antes de avançar o cadastro");

                return;
            }

            await handleCadastroConsulta();

            if (Object.keys(methods.formState.errors).length > 0) {
                return;
            }

            verificarCampoUcInscricao();
            setTabIndex(newValue);
            methods.setValue("tabIndex", newValue);
        } else {
            await handleCadastroConsulta();

            if (Object.keys(methods.formState.errors).length > 0) {
                return;
            }

            verificarCampoUcInscricao();
            setTabIndex(newValue);
            methods.setValue("tabIndex", newValue);
        }
    }

    const proximaAba = async () => {
        const situacaoNaoEditaveis = [1, 2, 4];

        if (erroAoRecuperarConsumidor) return;

        if (situacaoNaoEditaveis.includes(methods.getValues("Situacao"))) {
            if (tabIndex === 3) {
                return setTabIndex(0)
            } else {
                setTabIndex(tabIndex + 1);
            }

            return;
        }

        // Verifica se a cidade foi inserida
        // A validação é feita na aba de localização, para que não estoure aviso em outra tela
        // Caso não haja UC, deve-se obrigatoriamente definir uma cidade
        if (!methods.getValues("CodigoUC") && tabIndex === 1 && methods.getValues("CodigoCidade.value") === 0) {
            setTypeAlert("warning");
            setErrorMessage("É necessário informar uma cidade válida.");
            return setOpenError(true);
        }

        if (tabIndex === 0 && methods.getValues("Id") == 0) {
            if (methods.getValues("CodigoTipoGeracao") === undefined) {
                setTypeAlert("warning");
                setOpenError(true);
                setErrorMessage("É necessário salvar antes de avançar o cadastro");

                return;
            }

            await handleCadastroConsulta();

            if (Object.keys(methods.formState.errors).length > 0) {
                return;
            }

            verificarCampoUcInscricao();
        }

        let houveAlteracaoCampos = Object.keys(methods.formState.dirtyFields).length > 0;

        if (houveAlteracaoCampos) {
            await handleCadastroConsulta();

            if (Object.keys(methods.formState.errors).length > 0) {
                return;
            }

            verificarCampoUcInscricao();
        }

        if (tabIndex === 3) {
            return setTabIndex(0)
        }

        setTabIndex(tabIndex + 1);
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenError(false);
        }

        setOpenError(false);
    }

    const fecharJanela = () => {
        setEhNovoCadastro(false);
        setOpen(false);
    }

    const recuperarDadosConsumidor = async () => {
        try {
            setErroAoRecuperarConsumidor(false);

            if (!methods.getValues("CodigoUC") || !methods.getValues("Inscricao")) {
                return
            }

            const situacoesBloqueadas = [1, 4, 5, 6];

            if (situacoesBloqueadas.includes(recordForEdit?.Situacao) && methods.getValues('Id') != 0) return;

            let inscricao;

            if (methods.getValues("TipoInscricao")?.value == 1) {
                inscricao = formatarCnpj(methods.getValues("Inscricao"));
                inscricao = inscricao.replaceAll("_", "");
            } else {
                inscricao = formatarCnpj(methods.getValues("Inscricao"));
            }

            if (inscricao < 11) {
                return;
            }

            var dto = {
                CodigoUC: methods.getValues("CodigoUC"),
                Inscricao: inscricao
            };

            setIsLoading(true);

            const data = await ServConsultaAcesso.CarregarDadosDoConsumidor(dto);

            mapearCamposConsumidor(data.Content);
            setCamposDesabilitadosUc(true);
            setIsLoading(false);
        } catch (err) {
            setErroAoRecuperarConsumidor(true);
            mapearCamposConsumidorDefault();
            setCamposDesabilitadosUc(false);
            setIsLoading(false);
        }
    }

    const mapearCamposConsumidor = (data) => {
        if (data.Nome === methods.getValues("Nome")) {
            return;
        }

        methods.setValue("CEP", data.CEP);
        methods.setValue("CodigoCidade", {
            value: data.CodigoCidade,
            label: data.Cidade
        });
        methods.setValue("Celular1", data.Fone1);
        methods.setValue("Celular2", data.Fone2);
        methods.setValue("Nome", data.Nome);
        methods.setValue("NumeroEnd", data.NumeroEnd);
        methods.setValue("Rua", data.Rua);
        methods.setValue("Complemento", data.Complemento);
        methods.setValue("Endereco", data.Bairro);
        methods.setValue("UF", {
            value: data.UF,
            label: OpcoesUF.find((opcao) => opcao.value == data.UF).label
        });

        methods.setValue("Email", data.Email);
        if (data.Email.trim() === "") {
            methods.setValue("Email", " ");
        }

        if (data.Fone1.trim() === "") {
            methods.setValue("Celular1", data.FoneCelular);
        }
    }

    const handleEnter = (event) => {
        if (event.keyCode === 13) {
            const form = event.target.form;
            const index = Array.prototype.indexOf.call(form, event.target);
            form.elements[index + 1].focus();
            event.preventDefault();
        }
    }

    const handleClickOpenDialog = async (event, reason) => {
        try {
            // Verifica se a cidade foi inserida
            // A validação é feita na aba de localização, para que não estoure aviso em outra tela
            // Caso não haja UC, deve-se obrigatoriamente definir uma cidade
            if (!methods.getValues("CodigoUC") && methods.getValues("CodigoCidade.value") === 0) {
                setTypeAlert("warning");
                setErrorMessage("É necessário informar uma cidade válida na aba de Localização.");
                return setOpenError(true);
            }

            await handleCadastroConsulta();

            if (methods.getValues("TipoInscricao").value === 1) {
                let cpf = formatarNumero(methods.getValues("Inscricao"));

                if (cpf !== ' ' && !validarCpf(cpf)) {
                    setTypeAlert("warning");
                    setErrorMessage("A Inscrição informada é inválida");
                    return setOpenError(true);
                }
            } else {
                let cnpj = formatarCnpj(methods.getValues("Inscricao"));

                if (cnpj !== ' ' && !validarCnpj(cnpj)) {
                    setTypeAlert("warning");
                    setErrorMessage("A Inscrição informada é inválida");
                    return setOpenError(true);
                }
            }

            verificarCampoUcInscricao();

            if (reason === 'clickaway') {
                setOpenDialog(true);
            }

            setOpenDialog(true);
        } catch (err) {
            setOpenDialog(false);
            return setErrorMessage(err?.response?.data?.Message);
        }
    }

    const handleCloseDialog = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenDialog(false);
        }

        setOpenDialog(false);
    }

    const solicitarHomologacao = async () => {
        try {
            setIsLoading(true);

            await ServConsultaAcesso.EnviarParaAnalise(methods.getValues("Id"))

            setOpenError(true);
            setErrorMessage("Solicitação de análise enviada com sucesso.");
            setIsLoading(false);

            setOpenDialog(false);

            setTimeout(() => {
                setEhNovoCadastro(false);
                setOpen(false);
                pesquisar();
            }, [1400]);

        } catch (err) {
            setIsLoading(false);
            setOpenDialog(false);
            setErrorMessage(err?.response?.data?.Message);
            setTypeAlert("error");
            return setOpenError(true);
        }
    }

    const verificarCampoUcInscricao = (data) => {
        if (methods.getValues('Situacao') === 0) {
            if (data) {
                var { Inscricao, CodigoUC } = data;

                setDesabilitarUcInscricao(Inscricao && CodigoUC);
            } else {
                setDesabilitarUcInscricao(methods.getValues('Inscricao') && methods.getValues('CodigoUC'));
            }
        } else {
            setDesabilitarUcInscricao(true);
        }
    }

    return (
        <div className={styles['modal-main']}>
            {methods.getValues("Id") !== 0 && (
                <header className={styles.headerBonitao}>
                    <span className={styles.headerData}>
                        <div className={styles.dateBox}></div><b>Data de iní­cio:</b>{
                            format(parse(methods.getValues("DataCadastro"), 'dd/MM/yyyy HH:mm:ss', new Date()), "dd 'de' MMMM 'de' yyyy", {
                                locale: ptBR
                            })
                        }
                    </span>
                    {/* <span className={styles.headerData}>
                        <div className={`${styles.dateBox} ${styles['dateBox-green']}`}></div><b>Data prazo:</b>
                    </span> */}
                    {methods.getValues("Protocolo") && (
                        <><b>Protocolo:</b> {methods.getValues("Protocolo")}</>
                    )}
                </header>
            )}


            <FormProvider {...methods}>
                <form onSubmit={handleCadastroConsulta} >
                    <Box sx={{ width: '100%' }} className={styles.class100}>
                        <Box sx={{ marginLeft: '40px' }}>
                            <Tabs value={tabIndex} onChange={handleTabChange} aria-label="abas cadastro de consulta">
                                <Tab sx={{ color: "whitesmoke" }} label="Geral" {...a11yProps(0)} />
                                <Tab sx={{ color: "whitesmoke" }} label="Localização" {...a11yProps(1)} />
                                <Tab sx={{ color: "whitesmoke" }} label="Tensão" {...a11yProps(2)} />
                                <Tab sx={{ color: "whitesmoke" }} label="Documentos" {...a11yProps(3)} />
                            </Tabs>
                        </Box>
                        <TabPanel value={tabIndex} index={0} style={{ width: '100%' }}>
                            <Geral
                                setErrorMessage={setErrorMessage}
                                setIsLoading={setIsLoading}
                                setOpenError={setOpenError}
                                recuperarDadosConsumidor={recuperarDadosConsumidor}
                                camposDesabilitados={camposDesabilitados}
                                camposDesabilitadosSeHouverProtocolo={methods.getValues("Protocolo")}
                                camposDesabilitadosUc={camposDesabilitadosUc} erroAoRecuperarConsumidor={erroAoRecuperarConsumidor}
                                onKeyDown={handleEnter}
                                desabilitarUcInscricao={desabilitarUcInscricao}
                                uc={uc}
                            />
                        </TabPanel>
                        <TabPanel value={tabIndex} index={1}>
                            <Localizacao
                                setErrorMessage={setErrorMessage}
                                setIsLoading={setIsLoading}
                                setOpenError={setOpenError}
                                camposDesabilitados={camposDesabilitados}
                                camposDesabilitadosUc={camposDesabilitadosUc}
                                codigoUc={methods.getValues("CodigoUC")}
                                onKeyDown={handleEnter}
                                podeSalvar={podeSalvar}
                            />
                        </TabPanel>
                        <TabPanel value={tabIndex} index={2}>
                            <Tensao
                                setErrorMessage={setErrorMessage}
                                setIsLoading={setIsLoading}
                                setOpenError={setOpenError}
                                camposDesabilitados={camposDesabilitados}
                                camposDesabilitadosUc={camposDesabilitadosUc}
                                onKeyDown={handleEnter}
                            />
                        </TabPanel>
                        <TabPanel value={tabIndex} index={3}>
                            <Documentos
                                codigoSolicitacao={methods.getValues('Id')}
                                documentos={documentosObrigatorios}
                                setErrorMessage={setErrorMessage}
                                setOpenError={setOpenError}
                                situacaoConsultaAcesso={recordForEdit && !novoCadastro ? recordForEdit.Situacao : 0}
                                setIsLoading={setIsLoading}
                                setTypeAlert={setTypeAlert}
                            />
                        </TabPanel>
                    </Box>
                    <div className={styles['cadastrar-consulta-botoes']}>
                        <BlueHoverButton type="submit" disabled={!podeSalvar}>
                            Salvar
                        </BlueHoverButton>
                        {tabIndex == 3 && (
                            <BlueHoverButton onClick={handleClickOpenDialog} disabled={!podeSalvar}>
                                Solicitar análise
                            </BlueHoverButton>
                        )}
                        <BlueHoverButton onClick={proximaAba}>
                            {tabIndex == 0 ? (
                                <div>Informar localização</div>
                            ) : tabIndex == 1 ? (
                                <div>Informar dados da tensão</div>
                            ) : tabIndex == 2 ? (
                                <div>Informar documentos</div>
                            ) : (
                                <div>Informar dados gerais</div>
                            )}
                        </BlueHoverButton>
                        <BlueHoverButton onClick={fecharJanela}>
                            Cancelar
                        </BlueHoverButton>
                    </div>
                </form>
            </FormProvider>

            <Snackbar open={openError} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={typeAlert} sx={{ width: '100%' }}>
                    {errorMessage}
                </Alert>
            </Snackbar>
            <Modal open={isLoading}>
                <Box style={modalStyle}>
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: "#232323", fontWeight: "bold" }}>
                    {"Solicitar análise"}
                </DialogTitle>
                <DialogContent sx={{ backgroundColor: "#232323" }}>
                    <DialogContentText id="alert-dialog-description" sx={{ color: "whitesmoke" }}>
                        Você deseja solicitar a análise da consulta orçamento estimado?
                        Após a solicitação, o registro só poderá ser alterado em uma eventual reprovação.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ backgroundColor: "#232323" }}>
                    <BlueHoverButton onClick={handleCloseDialog}>Cancelar</BlueHoverButton>
                    <BlueHoverButton autoFocus onClick={solicitarHomologacao}>
                        Continuar
                    </BlueHoverButton>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export { Cadastro }